module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b073f1fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/refresh.vue
// module id = 1871
// module chunks = 2